import type LegalEntity from 'modules/core/store/models/LegalEntity'

import type { Employees } from 'modules/employees/store/collections/employees'
import type Employee from 'modules/employees/store/models/Employee'
import type EmployeeGroup from 'modules/employees/store/models/EmployeeGroup'

import { legalEntityEmployeeGroups } from './employeeGroups'

const employeeGroupEmployees = (employeeGroup: EmployeeGroup, employees: Employees) => {
  return employees.filter({
    employee_group_id: employeeGroup.attributes.id,
  })
}

export const legalEntityEmployees = (legalEntity: LegalEntity, employees: Employees) => {
  return legalEntityEmployeeGroups(legalEntity).reduce(
    (memo: Employee[], employeeGroup: EmployeeGroup) =>
      memo.concat(employeeGroupEmployees(employeeGroup, employees)),
    []
  )
}
